import 'regenerator-runtime/runtime';
import { put, call, takeLatest, all, select } from 'redux-saga/effects';
import { sendAjaxRequest } from 'helper/interceptors';
import { AppSettings } from '../constants';
import * as SettingActionType from './constants';
import * as NotifyActionType from 'Notification/constants';
import { getTranslations } from './selectors';

export function* getSettingNoticeRequestAsync() {
  const result = yield call(
    sendAjaxRequest,
    AppSettings.CURRENT_SITE_URI,
    '/api/settings/projects/request-for-services',
    {},
    'GET'
  );

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: SettingActionType.GET_SETTING_NOTICE_REQUEST_SUCCESS,
      data: result.data
    });
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* getSettingBuilderConfigAsync(action) {
  const result = yield call(
    sendAjaxRequest,
    AppSettings.CURRENT_SITE_URI,
    '/api/request-for-services/GetDefaultConfigs',
    {},
    'GET'
  );
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    const buildConfigs = {};
    result.data.map((config)=>buildConfigs[config.propertyName] =config.propertyValue )
    yield [
      put({
        type: SettingActionType.GET_SETTING_BUILDER_CONFIGS_SUCCESS,
        data: buildConfigs
      }),
    ];
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* updateSettingBuilderConfigAsync(action) {
  const result = yield call(
    sendAjaxRequest,
    AppSettings.CURRENT_SITE_URI,
    '/api/request-for-services/CreateDefaultConfigs',
    action.params,
    'POST'
  );
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    const bulkUpdateResult = yield call(
      sendAjaxRequest,
      AppSettings.SITE_ONE_SERVICE_URI,
      `/api/builder/accounts/bulkupdaterestrictclose/${action.params.PropertyValue}`,
      {},
      'POST'
    );
    if(bulkUpdateResult.statusCode === 200) {
      const buildConfigs = {};
      result.data.map((config)=>buildConfigs[config.propertyName] =config.propertyValue )
      yield [
        put({
          type: SettingActionType.GET_SETTING_BUILDER_CONFIGS_SUCCESS,
          data: buildConfigs
        }),
        put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Configuration Saved' }),
        put({
          type: SettingActionType.GET_SETTING_BUILDER_CONFIGS_SUCCESS_LOADER,
          statuscode: statusCode
        }),
      ];
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* updateSettingNoticeRequestAsync(action) {
  const result = yield call(
    sendAjaxRequest,
    AppSettings.CURRENT_SITE_URI,
    '/api/settings/projects/request-for-services',
    action.params,
    'PUT'
  );

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({
        type: SettingActionType.UPDATE_SETTING_NOTICE_REQUEST_SUCCESS,
        data: result.data
      }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' })
    ];
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* getSettingProjectOperationAsync() {
  const result = yield call(
    sendAjaxRequest,
    AppSettings.CURRENT_SITE_URI,
    '/api/settings/project-operations',
    {},
    'GET'
  );

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: SettingActionType.GET_SETTING_PROJECT_OPERATION_SUCCESS,
      data: result.data
    });
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* updateSettingProjectOperationAsync(action) {
  const result = yield call(
    sendAjaxRequest,
    AppSettings.CURRENT_SITE_URI,
    '/api/settings/project-operations',
    action.params,
    'PUT'
  );

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({
        type: SettingActionType.UPDATE_SETTING_PROJECT_OPERATION_SUCCESS,
        data: result.data
      }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' })
    ];
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* settingAssigneeNoticeBuilderLevelAsync(action) {
  const result = yield call(
    sendAjaxRequest,
    AppSettings.CURRENT_SITE_URI,
    '/api/settings/projects/notices',
    action.params,
    'PUT'
  );

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({
        type: SettingActionType.SETTING_ASSIGNEE_NOTICE_BUILDER_LEVEL_SUCCESS,
        data: result.data
      }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' })
    ];
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* getAssigneeNoticeBuilderLevelAsync() {
  const result = yield call(
    sendAjaxRequest,
    AppSettings.CURRENT_SITE_URI,
    '/api/settings/projects/notices',
    {},
    'GET'
  );

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({
        type: SettingActionType.SETTING_ASSIGNEE_NOTICE_BUILDER_LEVEL_SUCCESS,
        data: result.data
      })
    ];
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* getCustomTermsAsync() {
  const result = yield call(
    sendAjaxRequest,
    AppSettings.CURRENT_SITE_URI,
    `/${AppSettings.customTerms}`,
    {},
    'GET'
  );

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    const translations = yield select(getTranslations);
    translations.en = {
      ...translations.en,
      ...result.data
    };
    yield [
      put({ type: 'REDUX_I18N_SET_TRANSLATIONS', translations }),
      put({ type: 'REDUX_I18N_SET_FORCE_REFRESH', force: true })
    ];
  }
}

export function* updateCustomTermsAsync(action) {
  const result = yield call(
    sendAjaxRequest,
    AppSettings.CURRENT_SITE_URI,
    '/api/settings/custom-terms',
    action.params,
    'PUT'
  );

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    const translations = yield select(getTranslations);
    translations.en = {
      ...translations.en,
      ...action.params
    };
    yield [
      put({ type: 'REDUX_I18N_SET_TRANSLATIONS', translations }),
      put({ type: 'REDUX_I18N_SET_FORCE_REFRESH', force: true }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' })
    ];
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* updateCustomColorPalettesAsync(action) {
  const result = yield call(
    sendAjaxRequest,
    AppSettings.CURRENT_SITE_URI,
    '/api/settings/custom-style?IsbuilderSetting=1',
    action.params,
    'PUT'
  );

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({
        type: SettingActionType.UPDATE_CUSTOM_COLOR_PALETTES_SUCCESS,
        data: result.data.customStyleJson
      }),
      put({
        type: SettingActionType.SET_CURRENT_CUSTOM_COLOR,
        data: result.data.customStyleJson
      }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' })
    ];
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data[0] });
  }
}

export function* updateHOCustomColorPalettesAsync(action) {
  console.log('Color Pallete', action.params)
  const result = yield call(
    sendAjaxRequest,
    AppSettings.CURRENT_SITE_URI,
    '/api/settings/custom-style?IsbuilderSetting=2',
    action.params,
    'PUT'
  );

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({
        type: SettingActionType.UPDATE_HO_CUSTOM_COLOR_PALETTES_SUCCESS,
        data: result.data.customStyleJson
      }),
      put({
        type: SettingActionType.SET_HO_CURRENT_CUSTOM_COLOR,
        data: result.data.customStyleJson
      }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' })
    ];
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data[0] });
  }
}
export default function* WatchItemRepair() {
  yield all([
    takeLatest(
      SettingActionType.GET_SETTING_NOTICE_REQUEST_ASYNC,
      getSettingNoticeRequestAsync
    ),
    takeLatest(
      SettingActionType.GET_SETTING_BUILDER_CONFIG_ASYNC,
      getSettingBuilderConfigAsync
    ),
    takeLatest(
      SettingActionType.UPDATE_SETTING_BUILDER_CONFIG_ASYNC,
      updateSettingBuilderConfigAsync
    ),
    takeLatest(
      SettingActionType.UPDATE_SETTING_NOTICE_REQUEST_ASYNC,
      updateSettingNoticeRequestAsync
    ),
    takeLatest(
      SettingActionType.GET_SETTING_PROJECT_OPERATION_ASYNC,
      getSettingProjectOperationAsync
    ),
    takeLatest(
      SettingActionType.UPDATE_SETTING_PROJECT_OPERATION_ASYNC,
      updateSettingProjectOperationAsync
    ),
    takeLatest(
      SettingActionType.SETTING_ASSIGNEE_NOTICE_BUILDER_LEVEL_ASYNC,
      settingAssigneeNoticeBuilderLevelAsync
    ),
    takeLatest(
      SettingActionType.GET_ASSIGNEE_NOTICE_BUILDER_LEVEL_ASYNC,
      getAssigneeNoticeBuilderLevelAsync
    ),
    takeLatest(SettingActionType.GET_CUSTOM_TERMS, getCustomTermsAsync),
    takeLatest(SettingActionType.UPDATE_CUSTOM_TERMS, updateCustomTermsAsync),
    takeLatest(
      SettingActionType.UPDATE_CUSTOM_COLOR_PALETTES_ASYNC,
      updateCustomColorPalettesAsync
    ),
    takeLatest(
      SettingActionType.UPDATE_HO_CUSTOM_COLOR_PALETTES_ASYNC,
      updateHOCustomColorPalettesAsync
    )
  ]);
}



// WEBPACK FOOTER //
// ./src/Setting/saga.js